module.exports = __webpack_public_path__ + "img/about/80243-035.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-035.png
// module id = 35
// module chunks = 0